import { // SET_INSURANCE_CARRIER_RESPONSES,
  SET_FILTER_COVERAGE,
  SET_FILTER_COMPANY,
  SET_FILTER_PREMIUM_START,
  SET_FILTER_PREMIUM_END,
  SET_FILTER_SORT_BY,
  RESET_FILTERS,
  RESET_COMPARATION_QUOTATIONS,
  
  COMPARATION_PAGE_INITIALIZE_EXPECTED_PACKAGE_RESPONSES,
  SET_SELECTED_PACKAGES,
  COMPARATION_PAGE_ADD_PACKAGE_RESPONSE,
  COMPARATION_PAGE_INITIALIZE_INSURANCE_CARRIERS_RESPONSES,
  COMPARATION_PAGE_SET_PETITION_ALIVE,
} from 'Redux/types/comparationQuotationTypes';
import { computeQuotationPetitionAlive } from 'Redux/utils/computeQuotationPetitionAlive';

// const setInsuranceCarriersPackagesAction = (insuranceCarrierResponse) => ({
//   type: SET_INSURANCE_CARRIER_RESPONSES,
//   insuranceCarrierResponse,
// });
// export default (insuranceCarrierResponse) => (dispatch) => dispatch(setInsuranceCarriersPackagesAction(insuranceCarrierResponse));

const setFilterCoverageAction = (idCoverage) => ({
  type: SET_FILTER_COVERAGE,
  idCoverage,
});
export const setFilterCoverageDispatchAction = (idCoverage) => (dispatch) => dispatch(setFilterCoverageAction(idCoverage));


const setFilterCompanyAction = (idCompany) => ({
  type: SET_FILTER_COMPANY,
  idCompany,
});
export const setFilterCompanyDispatchAction = (idCompany) => (dispatch) => dispatch(setFilterCompanyAction(idCompany));

const setFilterPremiumStartAction = (premiumStart) => ({
  type: SET_FILTER_PREMIUM_START,
  premiumStart,
});
export const setFilterPremiumStart = (premiumStart) => (dispatch) => dispatch(setFilterPremiumStartAction(premiumStart));

const setFilterPremiumEndAction = (premiumEnd) => ({
  type: SET_FILTER_PREMIUM_END,
  premiumEnd,
});
export const setFilterPremiumEnd = (premiumEnd) => (dispatch) => dispatch(setFilterPremiumEndAction(premiumEnd));

const setFilterSortByAction = (sortBy) => ({
  type: SET_FILTER_SORT_BY,
  sortBy,
});
export const setFilterSortBy = (sortBy) => (dispatch) => dispatch(setFilterSortByAction(sortBy));

const resetFiltersAction = () => ({
  type: RESET_FILTERS,
});
export const resetFilters = () => (dispatch) => dispatch(resetFiltersAction());


const resetGlobalComparationQuotationActions = () => ({
  type: RESET_COMPARATION_QUOTATIONS,
});
export const resetGlobalComparationQuotation = () => (dispatch) => dispatch(resetGlobalComparationQuotationActions());


const initializeExpectedPackagesResponsesActionCreator = (insuranceCarriers) => ({
  type: COMPARATION_PAGE_INITIALIZE_EXPECTED_PACKAGE_RESPONSES,
  insuranceCarriers
});
export const initializeExpectedPackagesResponsesAction = (insuranceCarriers) => (dispatch) => dispatch(initializeExpectedPackagesResponsesActionCreator(insuranceCarriers));


const setSelectedPackagesAction = (newSelectedPackages) => ({
  type: SET_SELECTED_PACKAGES,
  selectedPackages: newSelectedPackages
});
export const setSelectedPackages = (newSelectedPackages) => (dispatch) => dispatch(setSelectedPackagesAction(newSelectedPackages));


const addPackageResponseActionCreator = (packageResponse) => ({
  type: COMPARATION_PAGE_ADD_PACKAGE_RESPONSE,
  packageResponse,
});
export const addPackageResponseAction = (packageResponse) => (dispatch, getState) => {
  dispatch(addPackageResponseActionCreator(packageResponse));
  dispatch(setPetitionAliveAction(computeQuotationPetitionAlive(getState())));
};

const initializeInsuranceCarriersResponsesActionCreator = (fullQuotation, insuranceCarriers) => ({
  type: COMPARATION_PAGE_INITIALIZE_INSURANCE_CARRIERS_RESPONSES,
  fullQuotation,
  insuranceCarriers,
});

export const initializeInsuranceCarriersResponsesAction = (fullQuotation) => (dispatch, getState) => {
  const { initialData } = getState();
  dispatch(initializeInsuranceCarriersResponsesActionCreator(fullQuotation, initialData.aseguradoras));
};

const setPetitionAliveActionCreator = (isAlive) => ({
  type: COMPARATION_PAGE_SET_PETITION_ALIVE,
  isAlive,
});
export const setPetitionAliveAction = (isAlive) => (dispatch) => dispatch(setPetitionAliveActionCreator(isAlive));
